/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Pros_2Inputs */

const en_pc_rv_pros_2 = /** @type {(inputs: Pc_Rv_Pros_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photoshop-style interface with almost no relearning`)
};

const zh_pc_rv_pros_2 = /** @type {(inputs: Pc_Rv_Pros_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photoshop 式界面，几乎不用重新学`)
};

/**
* | output |
* | --- |
* | "Photoshop-style interface with almost no relearning" |
*
* @param {Pc_Rv_Pros_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_pros_2 = /** @type {((inputs?: Pc_Rv_Pros_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Pros_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_pros_2(inputs)
	return zh_pc_rv_pros_2(inputs)
});
export { pc_rv_pros_2 as "pc.rv.pros.2" }